import { AxiosServiceClass } from '@/classes/axiosService.class';

class CartApiClass extends AxiosServiceClass {
	// Uncomment to point at local cart Api
	// endpointHost = 'https://localhost:44386/'
	// endpointPath = ''

	endpointPath = 'cart';

	endpointConfig = [
		{
			key: 'cart-post-build',
			path: (params) => `v1/cart/esr/exerpevent/${params.clubId}/${params.esrRegId}`,
			mock: 'literal'
		},
		{
			key: 'cart-post',
			path: () => 'v1/cart',
			mock: 'literal'
		},
		{
			key: 'cart-put',
			path: (cartId) => `v1/cart/${cartId}`,
			mock: 'literal'
		}
	];

	buildCart(cartData) {
		const items = buildCartItems(cartData);

		return this.post(
			this.endpoint('cart-post-build', {
				clubId: cartData.clubId,
				esrRegId: cartData.registrationId
			}),
			items,
			this.getConfig()
		);
	}

	createCart(cartData) {
		const item = buildCartItem(cartData, cartData.participants[0]);

		return this.post(
			this.endpoint('cart-post'),
			item,
			this.getConfig()
		);
	}

	addRemaining(cartData, cartId) {
		const url = this.endpoint('cart-put', cartId);
		let reqs = [];
		for (var i = 1; i < cartData.participants.length; i++) {
			reqs.push({
				url: url,
				body: buildCartItem(cartData, cartData.participants[i])
			});
		}
		return this.puts(
			reqs,
			this.getConfig()
		);
	}
}

export const CartApi = new CartApiClass();

function buildCartItem(cartData, person) {
	return {
		clubId : cartData.clubId,
		sourceId : person.attendeeId,
		sourceType : 'BOSS',
		quantity : 1,
		//promotionCode : '',
		metaData : [
			{
				key : 'agreementName',
				value : cartData.agreementName
			},
			{
				key : 'location',
				value : cartData.location
			},
			{
				key : 'firstName',
				value : person.firstName
			},
			{
				key : 'lastName',
				value : person.lastName
			},
			{
				key : 'reservationType',
				value : cartData.reservationType
			},
			{
				key : 'resourceName',
				value : cartData.resourceName
			},
			{
				key : 'resourceType',
				value : cartData.resourceType || ''
			},
			{
				key : 'startTime',
				value : cartData.startMoment.format()
			},
			{
				key : 'endTime',
				value : cartData.endMoment.format()
			},
			{
				key : 'price',
				value : cartData.unitCost.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
			},
			{
				key : 'expiresAt',
				value : cartData.expiresAt.format()
			},
			{
				key : 'registrationId',
				value: cartData.registrationId.toString()
			},
			{
				key : 'eventId',
				value : cartData.eventId.toString()
			}
		]
	};
}

function buildCartItems(cartData) {
	return cartData.participants.map(function(person) {
		let item = {
			clubId : cartData.clubId,
			sourceId : person.attendeeId,
			sourceType : 'EXERPEVENT',
			quantity : 1,
			metaData : [
				{
					key : 'MemberId',
					value : person.memberId.toString()
				},
				{
					key : 'ParticipantFirstName',
					value : person.firstName
				},
				{
					key : 'ClubName',
					value : cartData.location
				},
				{
					key : 'StartTime',
					value : cartData.startMoment.format()
				},
				{
					key : 'EndTime',
					value : cartData.endMoment.format()
				},
				{
					key : 'AgreementName',
					value : cartData.agreementName
				}
			]
		};
		if (cartData.instructors.length > 0) {
			item.metaData.push({
				key : 'PersonalTrainerName',
				value : cartData.instructors[0].name
			});
		}
		return item;
	});
}
